var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticClass:"rounded-circle",attrs:{"size":_vm.size,"color":_vm.$vuetify.theme.dark ? 'grey lighten-2' : 'grey darken-1'},on:{"click":function($event){return _vm.toggleThemeDarkMode()}}})}
var staticRenderFns = []

export { render, staticRenderFns }